import React from 'react';
import { Link } from 'react-router-dom';
import Map from './Map';
import '../../App.css';
// import Cards from '../Cards';
// import HeroSection from '../HeroSection';
import Footer from '../Footer';
import './Home.css';


function Home() {
  return (
    <>
    {/* <h1>Home</h1> */}
    <div className='hero-container home half'> 
    <div className='logo-container'>
      <img src={require('../../img/main_logo_600px.png')} className='img homepage-logo'/>
    </div>
    </div>
    <div className='info-container'>
      <div className='about-blurb'>
        {/* <h2>About Us</h2> */}
        <p>
        Grace Community Fellowship is a non-denominational body of believers seeking to honor the name of Jesus Christ in the greater Georgetown area. To that end, we’re committed to worshiping God through the expositional preaching of His authoritative word, the ongoing discipleship of the saints, and the spreading of the gospel.  We strive to cultivate the warm fellowship that can only be found among redeemed brothers and sisters in Christ. 
        It would be our sincere joy to have you join us in person.
        </p>
        <Link to='/about/history'><button className='btn btn-primary btn-home'>History</button></Link>
        <Link to='/about/statement-of-faith'><button className='btn btn-primary'>Statement of Faith</button></Link>

      </div>
      <div className='location'>
      <div className='info'>
        <h2 id='join-us'>Join us Sundays at 10:30</h2>
        <p>7600 West State Highway 29</p>
        <p>Georgetown, TX 78628</p>
        </div>
      <div className='widget'>
          <Map loading='lazy'/>
          </div>
      </div>
    </div>
    {/* <div className='vbs'>
      <div>
        <img src={require('../../img/vbs_2026.jpg')}/>
        <h2>VBS 2026</h2>
        <h3>July 13 - 17 | 9am - 12pm</h3> 
        <Link target='_blank' to='https://gcftxmyanswersmyanswers.myanswers.com/emerald-crossing/'><button className='btn btn-primary'>Register</button></Link></div>
    </div> */}
    {/* Calendar iFrame */}
    {/* <div className='events'>
      <h2>Calendar</h2>
      <div className='main'> 
          <iframe 
          tabIndex="-1" 
          width="1" 
          height="700" 
          src="https://gcftx.ccbchurch.com/goto/events/public?focus=month&view=calendar" 
          style={{"min-width": "100%", "max-width": "100%"}} 
          frameBorder="0" 
          scrolling="no"
          loading="lazy" // this doesn't seem to do anything for the jumping
          >
          </iframe>
        </div>
      </div> */}
      <div className='link-trio'>
          <Link  to='/calendar'>
            <div class="trio-div">
              <img
                class="trio-img"
                src={require('../../img/ladies_christmas_tea_23_400px.jpg')}
                alt=""
                loading='lazy'
              />
              <div class="trio-text">
                <h3>Calendar</h3>
              </div>
            </div>
          </Link>

          <Link  to='/sermons'>
          <div class="trio-div">
              <img
                class="trio-img"
                src={require('../../img/sermons_2_400px.jpg')}
                alt=""
                loading='lazy'
              />
              <div class="trio-text">
                <h3>Sermons</h3>
              </div>
            </div>
          </Link>

          <Link  to='/ministries/outreach'>
          <div class="trio-div">
              <img
                class="trio-img"
                src={require('../../img/ministries1_400px.jpg')}
                alt=""
                loading='lazy'
              />
              <div class="trio-text">
                <h3>Outreach</h3>
              </div>
            </div>
          </Link>

      </div>

    <Footer />
    </>
  );
}

export default Home;